// extracted by mini-css-extract-plugin
export var carrierIcon = "_z9-0";
export var carrierLogo = "_z9-1";
export var detailsSection = "_z9-2";